// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/routes/($lang).kantonsrat.sitzungen.id.$id.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/routes/($lang).kantonsrat.sitzungen.id.$id.tsx");
  import.meta.hot.lastModified = "1763993705268.2295";
}
// REMIX HMR END

/* eslint-disable jsx-a11y/media-has-caption */
import { json } from "@remix-run/node";
import { Link, useLoaderData } from "@remix-run/react";
import { convertXML } from 'simple-xml-to-json';
import { marked } from 'marked';
import SYS_CONFIG from "~/config";
import { extractSitzungenSeachDetailResponse } from "~/utils/forParlZH";
import { extractUrl, removeTrailingSlash, timeNoDate } from "~/utils/strings";
import { useLang } from "~/utils/provider/lang-provider";
import { langByParam } from "~/utils/lang";
import dict from "~/locales";
import { createHrefLangObjForMetas } from "~/utils/metas";
import { getMatchFromMatchesByPageHandle } from "~/utils/handle";
import NotFound from "~/components/NotFound";
export const handle = {
  page: SYS_CONFIG.PAGE_HANDLES.H_KANTONSRAT_SIZTUNGEN_ITEM
};
export const headers = () => {
  return SYS_CONFIG.CACHE_CONTROL;
};
export const loader = async ({
  params
}) => {
  const {
    id
  } = params;
  const res = await fetch(encodeURI(`https://parlzhcdws.cmicloud.ch/parlzh3/cdws/Index/SITZUNGENDETAIL/searchdetails?q=obj_guid adj ${id} sortBy datum_start/sort.descending&l=de-CH&m=50`));
  const xml = await res.text();
  if (xml) {
    const outp = await convertXML(xml);
    const converted = extractSitzungenSeachDetailResponse(outp, 'full');
    if (converted?.length) {
      return json({
        feed: converted
      }, {
        headers: SYS_CONFIG.CACHE_CONTROL
      });
    } else {
      return json({
        feed: converted,
        notFound: true
      }, 404);
    }
  }
  return null;
};
export const meta = ({
  params,
  location,
  matches
}) => {
  const {
    lang
  } = params;
  const langObj = langByParam(lang);
  const {
    pathname
  } = location;
  const {
    URL_SITE_DOMAIN
  } = SYS_CONFIG;
  const metas = dict[langObj.lang_code].metas;
  const routeMatchesData = getMatchFromMatchesByPageHandle(matches, SYS_CONFIG.PAGE_HANDLES.H_KANTONSRAT_SIZTUNGEN_ITEM)?.data;
  if (routeMatchesData && typeof routeMatchesData === 'object' && 'feed' in routeMatchesData) {
    const feed = routeMatchesData.feed;
    if (Array.isArray(feed) && feed.length === 1) {
      const item = feed[0];
      return [{
        title: item.titel
      }, {
        name: 'description',
        content: `${item.titel}, ${item.datum}, ${item.uhrzeit}. ${item.gremiumName} (${item.gremiumKurzname}) - ${item.gremiumTyp}. ${metas.m_d_kantonsrat_sitzungen_item_suffix}`
      }, {
        tagName: "link",
        rel: "canonical",
        href: URL_SITE_DOMAIN + removeTrailingSlash(pathname)
      }, {
        property: "og:url",
        content: URL_SITE_DOMAIN + removeTrailingSlash(pathname)
      }, {
        property: 'og:locale',
        content: langObj.lang_code
      }, {
        property: 'og:image',
        content: URL_SITE_DOMAIN + `/_static/icons/logo512x512.png`
      }, {
        property: 'og:image:width',
        content: 512
      }, {
        property: 'og:image:height',
        content: 512
      }, ...createHrefLangObjForMetas(pathname)];
    }
  }
  return [];
};
export default function KantonsratSitzungItem() {
  _s();
  const loaderData = useLoaderData();
  const l_kantonsrat = useLang('kantonsrat');
  if (loaderData?.notFound) return <NotFound />;
  const item = loaderData?.feed[0];
  if (!item) return null;
  const location = item.ort ? item.ort : 'Kantonshaus, Schanzengraben 29, Zürich.';
  return <>
            <h1>{item.titel}</h1>

            <div itemScope itemType="http://schema.org/Event">
                {!item.ort ? <meta itemProp="location" content={location} /> : null}
                {item.videoStream && extractUrl(item.videoStream)?.indexOf('https://vimeo.com') === -1 ? <div itemProp="subjectOf" itemScope itemType="http://schema.org/VideoObject">
                        <meta itemProp="uploadDate" content={item.sitzungsende} />
                        <meta itemProp="name" content={item.titel} />
                        <link itemProp="contentUrl url" href={extractUrl(item.videoStream)} />
                        <link itemProp="embedUrl" href={extractUrl(item.videoStream)} />
                        <iframe className="i_frame" src={extractUrl(item.videoStream) ?? ''} title={item.titel} width="768" allowFullScreen frameBorder={0} />
                    </div> : null}


                <div className="overflow_frame">

                    <table className="table_item_1">
                        <tbody>
                            <tr>
                                <th className="t_sub_hdr" colSpan={2} itemProp="organizer" itemScope itemType="http://schema.org/GovernmentOrganization">
                                    <link itemProp="url" href="https://www.kantonsrat.zh.ch" />
                                    <span itemProp="name">{item.gremiumName}</span>
                                    {' '}
                                    (<span itemProp="alternateName">
                                        {item.gremiumKurzname}
                                    </span>)
                                </th>
                            </tr>
                            <tr>
                                <th>
                                    {l_kantonsrat('l_title')}
                                </th>
                                <td itemProp="name">{item.titel}</td>
                            </tr>
                            <tr>
                                <th>{l_kantonsrat('l_type')}</th>
                                <td>{item.gremiumTyp}</td>
                            </tr>
                            <tr>
                                <th>{l_kantonsrat('l_date')}</th>
                                <td>{item.datum}</td>
                            </tr>
                            <tr>
                                <th>{l_kantonsrat('l_time')}</th>
                                <td>
                                    <time itemProp="startDate" dateTime={item.sitzungsbeginn}>
                                        {timeNoDate(item.sitzungsbeginn)}
                                    </time>
                                    -
                                    <time itemProp="endDate" dateTime={item.sitzungsende}>
                                        {timeNoDate(item.sitzungsende)}
                                    </time>
                                </td>
                            </tr>
                            {item.ort ? <tr itemProp="location" itemScope itemType="http://schema.org/Place">
                                    <th>{l_kantonsrat('l_ort')}</th>
                                    <td itemProp="name">{item.ort}</td>
                                </tr> : null}
                            {item.traktanden?.length ? <tr>
                                    <th>{l_kantonsrat('l_traktanden')}</th>
                                    <td>
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th style={{
                        width: 'unset'
                      }} className="t_sub_hdr">{l_kantonsrat('l_number_short')}</th>
                                                    <th style={{
                        width: 'unset'
                      }} className="t_sub_hdr">{l_kantonsrat('l_title')}</th>

                                                </tr>
                                            </thead>
                                            <tbody itemProp="about" itemScope itemType="http://schema.org/ItemList">
                                                {item.traktanden.map((it, ind) => <tr key={ind} itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
                                                        <td itemProp="identifier">{it.trak_krnummer ? it.trak_krnummer : it.trak_vorlagennummer}
                                                        </td>
                                                        <td itemProp="name">{it.trak_titel}
                                                            {it.trak_unterlagen ? <div>{it.trak_unterlagen}</div> : null}

                                                        </td>
                                                    </tr>)}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr> : null}

                            {item.dokumente?.length ? <tr>
                                    <th>{l_kantonsrat('l_documents')}</th>
                                    <td><ul className="ul_1" style={{
                  margin: 0
                }}>
                                        {item.dokumente.map((it, ind) => <li itemProp="subjectOf" itemScope itemType="http://schema.org/CreativeWork" key={ind}>
                                                <link itemProp="url" content={`https://parlzhcdws.cmicloud.ch/parlzh3/cdws//Files/${it.dokurl}/pdf`} />
                                                <Link className="a_1" to={`https://parlzhcdws.cmicloud.ch/parlzh3/cdws//Files/${it.dokurl}/pdf`}>
                                                    <span itemProp="name">
                                                        {it.doktitel}
                                                    </span>
                                                </Link>
                                            </li>)}
                                    </ul>
                                    </td>
                                </tr> : null}

                            {item.videoStream && extractUrl(item.videoStream)?.indexOf('https://vimeo.com') !== -1 ? <tr itemProp="subjectOf" itemScope itemType="http://schema.org/VideoObject">
                                    <th>{l_kantonsrat('l_video')}</th>
                                    <td>
                                        <meta itemProp="uploadDate" content={item.sitzungsende} />
                                        <meta itemProp="name" content={item.titel} />
                                        <link itemProp="contentUrl url" href={extractUrl(item.videoStream)} />
                                        <link itemProp="embedUrl" href={item.videoStream} />
                                        <Link className="a_1" to={extractUrl(item.videoStream)}>
                                            {new URL(extractUrl(item.videoStream)).host}
                                        </Link>
                                    </td>
                                </tr> : null}
                        </tbody>
                    </table>

                    {item.bulletinTeaser ? <h2>{item.bulletinTeaser}</h2> : null}

                    {item.bulletin ? <section className="foreign_html" dangerouslySetInnerHTML={{
          __html: marked.parse(item.bulletin)
        }} /> : null}

                    {item.amMontagImKantonsrat ? <section className="foreign_html" dangerouslySetInnerHTML={{
          __html: marked.parse(item.amMontagImKantonsrat)
        }} /> : null}

                    <div className="padding05rem">{l_kantonsrat('l_data')}: <Link className="a_1" to={`https://opendata.swiss/de/dataset/organisation-und-geschafte-des-zurcher-kantonsrats`}>opendata.swiss</Link>,
                        <Link className="a_1" to={`https://www.kantonsrat.zh.ch/`}>Kantonsrat Zürich</Link>
                    </div>

                </div>
            </div>
        </>;
}
_s(KantonsratSitzungItem, "EEOFWdp/9FqIya7liLPBXmIYS3U=", false, function () {
  return [useLoaderData, useLang];
});
_c = KantonsratSitzungItem;
var _c;
$RefreshReg$(_c, "KantonsratSitzungItem");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;